import angular from "angular";

(function() {
    angular
        .module("vrm.core")
        .controller("RemoteConsoleController2", RemoteConsoleController2);

    /**
     * @constructor
     * @ngInject
     */
    function RemoteConsoleController2(
        $state,
        InstallationsService,
        $stateParams,
        RemoteConsole2Service
    ) {
        function open() {
            RemoteConsole2Service.addBodyClass();
            const {
                isMobile,
                isTablet
            } = RemoteConsole2Service.setupMobileDetection();

            InstallationsService.getInstallation($stateParams.id).then(
                installation => {
                    if (
                        !RemoteConsole2Service.validatePermissions(
                            installation,
                            $state,
                            $stateParams,
                            false
                        )
                    ) {
                        return;
                    }

                    const eventListeners = RemoteConsole2Service.setupEventListeners(
                        isMobile,
                        isTablet
                    );
                    RemoteConsole2Service.loadRemoteConsole(
                        installation,
                        $stateParams,
                        false,
                        false
                    );
                    $scope.$on("$destroy", function() {
                        RemoteConsole2Service.removeBodyClass();
                        eventListeners.cleanup();
                    });
                }
            );
        }

        open();
    }
})();
